/* Ajusta el tamano del texto de la vista previa para que ocupe el mismo ancho
   que la impresion real: 20 mm sobre una pelota de 42.67 mm de diametro, es
   decir ~47% del ancho de la pelota. El ancho objetivo se puede cambiar con
   --mb-p-width en el contenedor .mb-perso (porcentaje del ancho de la pelota).

   Se mide el texto ya renderizado y se escala para que quepa en ese ancho, asi
   una W o una M no se salen y una I no se ve perdida. Una sola letra tiene tope
   de altura para que no se vea gigante.

   Va aparte de los scripts de personalizacion para que aplique en las dos
   pantallas donde vive la vista previa (ficha de pelota y ficha del servicio)
   sin duplicar logica. Si el JS no corre, el CSS usa reglas [data-len] como
   respaldo con tamanos equivalentes. */
(function () {
  var DEFAULT_WIDTH = 0.47; // 20 mm / 42.67 mm
  var MAX_FONT = 0.24;      // tope de tamano de letra, como fraccion del ancho de la pelota

  function targetFraction(scope) {
    var raw = parseFloat(getComputedStyle(scope).getPropertyValue('--mb-p-width'));
    return isFinite(raw) && raw > 0 ? raw / 100 : DEFAULT_WIDTH;
  }

  function fit(el) {
    var box = el.closest('.mb-perso-ball');
    if (!box) return;
    var W = box.clientWidth;
    if (!W) { el.style.fontSize = ''; return; }
    var scope = el.closest('.mb-perso') || box;
    var target = W * targetFraction(scope);

    el.style.fontSize = '100px';
    var w = el.getBoundingClientRect().width;
    if (!w) { el.style.fontSize = ''; return; }

    var size = 100 * target / w;
    size = Math.min(size, W * MAX_FONT);
    el.style.fontSize = size.toFixed(1) + 'px';
  }

  function sync() {
    var nodes = document.querySelectorAll('[data-mb-perso-text]');
    for (var i = 0; i < nodes.length; i++) {
      var n = (nodes[i].textContent || '').trim().length;
      if (n > 5) n = 5;
      if (n > 0) {
        nodes[i].setAttribute('data-len', String(n));
        fit(nodes[i]);
      } else {
        nodes[i].removeAttribute('data-len');
        nodes[i].style.fontSize = '';
      }
    }
  }

  function bind() {
    document.querySelectorAll('[data-mb-perso-input]').forEach(function (input) {
      if (input.dataset.mbSizeBound === '1') return;
      input.dataset.mbSizeBound = '1';
      ['input', 'change', 'blur', 'keyup'].forEach(function (ev) {
        input.addEventListener(ev, function () { setTimeout(sync, 0); });
      });
    });
    sync();
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  if (document.readyState !== 'loading') bind();
  setTimeout(bind, 600);
  setTimeout(bind, 1800);
  window.addEventListener('resize', function () { setTimeout(sync, 0); });

  if (window.MutationObserver) {
    document.addEventListener('DOMContentLoaded', function () {
      var scope = document.querySelector('.product__info-container') || document.body;
      new MutationObserver(function () { bind(); }).observe(scope, { childList: true, subtree: true });
    });
  }
})();
